<template>
    <div class="cartas-proposta-digitacao">
        <g-card class="card-form-ReclamacaoTec" :expansivel="true" :comecaFechado="false">
            <template #cabecalho>
                <div class="header-filtros">
                    <div class="titulo-filtros-cabecalho"> Reclamação Técnica / Comercial </div>
                    <div class="header-icons">
                        <g-button
                        class="trash-box"
                        tipo="cinza" altura="35px"
                        largura="45px"
                        icone="icone_lixo.svg"
                        tamanhoIcone="15px"
                        somenteIcone
                        :sombreado="false"
                        v-tooltip="'Limpar filtro'"
                        @click="clear" />
                        <g-button
                        class="plus-button"
                        corIconeClass="#FFF"
                        cor="#4F2C19"
                        altura="35px"
                        largura="45px"
                        icone="pi pi-plus"
                        tamanhoIcone="15px"
                        somenteIcone
                        :sombreado="false"
                        @click="abrePopup" />
                        <g-button
                        class="buscar-button-header-filtro"
                        largura="150px" icone="icone_lupa.svg"
                        negritoTexto
                        tamanhoIcone="15px"
                        tamanhoTexto="15px"
                        altura="35px"
                        gap="10px"
                        :sombreado="false"
                        @click="Grid()">
                            BUSCAR
                        </g-button>
                    </div>
                </div>
            </template>

            <PDialog  :closable="false" :style="{ width: '50%', margin: '0 5%', minWidth: '300px', maxWidth: '42em' }"
            class="gama-popup" v-model:visible="popup">
                <template #header>
                    <div class="titulo-formulario"> Adicionar Formulário </div>
                </template>
                <div class="grupo-formulario espacamento-filtros">
                    <div class="titulo-popup-finalizado"> Selecione o Cliente, Unidade e o Representante </div>
                    <div class="conteudo-grupo-formulario">
                        <div class="popup-unidade">
                            <div class="unidade-input titulo-conteudo-filtros"> Unidade </div>
                            <PDropDown 
                            maxlength="125" 
                            :options="EmpresaArrayPopup" 
                            optionLabel="nome"
                            optionValue="id" 
                            placeholder="Selecione a Unidade"
                            v-model="EmpresaSelecionada" 
                            />
                        </div>

                        <div class="popup-representante">
                            <div class="representante-input titulo-conteudo-filtros"> Representante </div>
                            <PDropDown
                            placeholder="Selecione o representante"
                            :filter="true" 
                            @filter="buscarRepresentante($event.value)"
                            :options="RepresentantesArray"
                            optionLabel="codigoNomeRepresentante"
                            optionValue="representanteId"
                            v-model="RepresentanteSelecionado"
                            />
                        </div>

                        <div class="popup-cliente">
                            <div class="cliente-input titulo-conteudo-filtros"> Cliente </div>
                            <cliente-dropdown
                            class="p-dropdown cliente"
                            v-model="ClienteSelecionado"
                            :empresaId="objFiltros.UnidadeId"
                            :representanteId="this.$store.state.representanteSelecionadoId"
                            />
                        </div>
                    </div>
                </div>

                <div class="botoes-popup button-popup">
                    <div>
                        <g-button
                        tipo="cinza"
                        negritoTexto 
                        largura="230px" 
                        altura="35px" 
                        @click="fechaPopup"
                        >
                            VOLTAR
                        </g-button>
                    </div>
                    <div>
                        <g-button
                        negritoTexto
                        largura="230px" 
                        altura="35px" 
                        @click="valida"
                        >
                            INICIAR FORMULÁRIO   
                        </g-button>
                    </div>
                </div>
            </PDialog>
            <g-form>
                <div class="ReclamacaoTec-conteudo espacamento-filtros">
                    <div class="filtr-unidade">
                        <div class="titulo-conteudo-filtros"> Unidade </div>
                        <PDropDown
                        v-model="objFiltros.UnidadeId"
                        class="input-label unidade"
                        :options="EmpresaArray"
                        optionLabel="nome"
                        optionValue="id"
                        placeholder="TODAS"
                        ></PDropDown>
                    </div>

                    <div class="filtr-cliente">
                        <div class="titulo-conteudo-filtros"> Cliente </div>
                        <cliente-dropdown
                            class="p-dropdown cliente"
                            v-model="objFiltros.ClienteId"
                            :empresaId="objFiltros.UnidadeId"                       
                            :representanteId="this.$store.state.representanteSelecionadoId"
                        />
                    </div>

                    <div class="filtro-numero-formulario">
                        <div class="titulo-conteudo-filtros"> Nº do formulário </div>
                        <PInputText class="produto-input input-label" placeholder="Insira o número"
                            v-model="objFiltros.NumeroFormulario" />
                    </div>

                    <div class="filtro-numero-pedido">
                        <div class="titulo-conteudo-filtros"> Nº do pedido </div>
                        <PInputText class="input-label" placeholder="Insira o número"
                            v-model="objFiltros.NumeroPedido" />
                    </div>
                </div>
            </g-form>

            <div class="buscar-button-filtro">
                <g-button
                class="buscar-button"
                largura="300px"
                icone="icone_lupa.svg"
                negritoTexto
                tamanhoIcone="15px"
                tamanhoTexto="15px"
                altura="35px"
                gap="10px"
                :sombreado="false"
                @click="Grid()"
                >
                    BUSCAR
                </g-button>
            </div>
        </g-card>

        <g-card v-if="mensagemvazio" paddingDefault="1em 0 3em" :temCabecalho="false">
            <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
            <div class="texto-padrao-imagemfundo">
                Verifique os filtros e clique em buscar para exibir os resultados
            </div>
        </g-card>

        <g-card v-else-if="!mensagemvazio" paddingDefault="0em 0 3em" :temCabecalho="false">
            <g-data-table
            class="datatable-ReclamacaoTec"
            altura="auto"
            Titulo="Reclamações"
            :colunas="Colunas"
            :Filtros="Filtro"
            :FiltrosEspecificos="true"
            :Imprimivel="true"
            :NumeroLinhas="100"
            :numeroBotoesAcao="1"
            :Paginacao="true"
            :valores="ReclamacaoArray"
            v-on:clickImprimir="imprimir"
            v-on:duploClickLinha="detalhesReclamacoesTecnicas"
            :campoAgrupador="'empresaCliente'"
            :campoExibicaoGrupo="'empresaCliente'"
            >
            </g-data-table>
        </g-card>
    </div>
    <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
        <div class="container-logo">
            <img class="logo-login" src="@/assets/imgs/grupo_jauense_logo.svg">
        </div>
        <div class="render" v-if="renderiza">
            <ReclamacaoTecnicaComercialPDF :tituloDetalhes="false" v-on:termino="gerarPdf" :reclamacaoTecnicaSelecionada="ReclamacaoTecnicaId"></ReclamacaoTecnicaComercialPDF>
        </div>
    </g-pdf>
</template>

<script>
import ReclamacaoTecnicaComercial from './ReclamacaoTecnicaComercial.js'
export default ReclamacaoTecnicaComercial
</script>

<style scoped>
.container-logo{
  padding: 30px 30px 10px 53px;
}
.button-popup {
  margin: 50px 0 15px;
}

@media (max-width:310px) {
}

@media (min-width:310px) {

}

@media (min-width:368px) {

}


@media (min-width:600px) {
.ReclamacaoTec-conteudo {
    display: grid;
    grid-template-columns: minmax(6em, 49%) minmax(6em, 49.5%);
    grid-template-rows: repeat(2, auto);
    grid-column-gap: 20px;
}

.filtro-unidade {
  grid-area: 1 / 1 / 2 / 2;
}
.filtro-cliente {
  grid-area: 1 / 2 / 2 / 3;
}
.filtro-numero-formulario {
  grid-area: 2 / 1 / 3 / 2;
}
.filtro-numero-pedido {
  grid-area: 2 / 2 / 3 / 3;
}

.empresa { display: none; }

.conteudo-grupo-formulario {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, auto);
    grid-column-gap: 20px;
}

.popup-unidade { grid-area: 1 / 1 / 2 / 3; }
.popup-representante { grid-area: 2 / 1 / 3 / 2; }
.popup-cliente { grid-area: 2 / 2 / 3 / 3; }
}

@media (min-width:801px) {

}

@media (min-width:1025px) {
.ReclamacaoTec-conteudo {
    grid-template-columns: repeat(2, minmax(6em, 28em)) repeat(2,minmax(6em, 13em));
    grid-template-rows: auto;
  }
.filtro-numero-formulario {
    grid-area: 1 / 3 / 2 / 4;
    width: 100%;
}

.filtro-numero-pedido {
    grid-area: 1 / 4 / 2 / 5;
    width: 100%;
}
}

@media (max-width:1281px) {

}

@media (min-width:1500px) {

}
</style>